import React, { useEffect } from 'react';
import {
  Card, CardContent, Typography, Link,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { LoginForm } from './components';
import { images } from '../../shared/utils/public';
import { Path } from '../../shared/enums';
import { AIRA_URL } from '../../shared/utils/constants';
import loginService from './services/login-service';
import useUserContext from '../../context/user/context';
import { LoginAttributes } from '../../interfaces';

export default function Login() {
  const navigate = useNavigate();
  const { setUser, isUserAuthenticated, setIsUserAuthenticated } = useUserContext();

  useEffect(() => {
    if (isUserAuthenticated) navigate(Path.TRIALS);
  }, [isUserAuthenticated, navigate]);

  const handleLogin = async (loginAttributes: LoginAttributes) => {
    try {
      const user = await loginService.login(loginAttributes);

      setUser(user);
      setIsUserAuthenticated(true);
      navigate(Path.TRIALS);
    } catch { }
  };

  return (
    <div className="w-full h-full flex flex-col justify-center items-center">
      <div className="h-full flex items-center">
        <Card className="w-130 pr-10 pl-10 pt-12 pb-20">
          <CardContent className="flex flex-col">
            <div className="flex justify-center mb-12">
              <img
                src={images.grLogo.src}
                alt={images.grLogo.alt}
                width="100px"
              />
            </div>

            <div className="mb-10">
              <Typography variant="h1">Login</Typography>
            </div>

            <LoginForm onLoginSubmit={handleLogin} />
          </CardContent>
        </Card>
      </div>

      <div className="flex flex-row items-center mb-5">
        <Typography variant="h4" color="text.secondary">
          Desenvolvido por
          <Link href={AIRA_URL} color="#0072BA"> Aira.Blue </Link>
        </Typography>
        <img
          className="ml-1"
          src={images.airaLogo.src}
          alt={images.airaLogo.alt}
          width="20px"
        />
      </div>
    </div>
  );
}
